// extracted by mini-css-extract-plugin
module.exports = {"fieldContainer":"PromotionBarSlideEditModal_fieldContainer__1ICVZ","field":"PromotionBarSlideEditModal_field__2d40r","flag":"PromotionBarSlideEditModal_flag__ftt6A"};